export const GET_LEADS_LEAD_MANAGE = 'GET_LEADS_LEAD_MANAGE';
export const GET_LEADS_LEAD_MANAGE_SUCCESS = 'GET_LEADS_LEAD_MANAGE_SUCCESS';
export const GET_LEADS_LEAD_MANAGE_FAILURE = 'GET_LEADS_LEAD_MANAGE_FAILURE';

export const COUNT_LEADS_SUCCESS = 'COUNT_LEADS_SUCCESS';
export const COUNT_LEADS_FAILURE = 'COUNT_LEADS_FAILURE';

export const SET_LEAD_MANAGE_KEY = 'SET_LEAD_MANAGE_KEY';
export const SET_LEAD_MANAGE_NEW_KEY_VALUE = 'SET_LEAD_MANAGE_NEW_KEY_VALUE';
export const UPDATE_LEAD_MANAGE_KEY = 'UPDATE_LEAD_MANAGE_KEY';
export const TOGGLE_SHOW_LEADS_ADDITIONAL_FILTERS = 'TOGGLE_SHOW_LEADS_ADDITIONAL_FILTERS';

export const SET_LEAD_MANAGE_LOADING = 'SET_LEAD_MANAGE_LOADING';

export const SET_LEAD_MANAGE_PAGINATION = 'SET_LEAD_MANAGE_PAGINATION';



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/constants/get_leads.constants.js